import {
  DEFAULT_FRAGMENT,
  SPLIT_PAGE_FRAGMENT,
  ASSET_FRAGMENT,
} from "./fragments";
const gql = String.raw;

export const getPageByBookIdQuery = (bookSlug: string): string => gql`
  ${ASSET_FRAGMENT}
  ${DEFAULT_FRAGMENT}
  ${SPLIT_PAGE_FRAGMENT}
  

  query PageQuery {
    book(filter: { slug: { eq: "${bookSlug}" } }) {
      id
      pages {
        ...DefaultFragment
        ...SplitPageFragment
      }
      }
  }`;
